export default [
  '$window',
  '$document',
  function infiniteScroll($window, $document) {
    return {
      restrict: 'A',
      link: (scope, elm, attrs) => {
        let el = elm[0];

        let scrollFunc = () => {
          if (angular.element($window).scrollTop() + angular.element($window).height() >= el.scrollHeight + el.offsetTop) {
            scope.$apply(attrs.infiniteScroll);
          }
        };

        $document.on('scroll', scrollFunc);

        elm.on('$destroy', () => {
          $document.off('scroll', scrollFunc);
        })
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/infinite-scroll/infinite-scroll.dir.js